import {
  Box,
  Button,
  Flex,
  Input,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AlertModal from "../../../Modals/AlertModal";
import { mixpanelTrackButton } from "../../../utils/mixpanelFunctions";
import {
  getConstraintsWithWeightageApi,
  updateConstraintsWithWeightageApi,
} from "./services/constraintsWithWeightageServices";

export const ConstraintsWithWeightage = () => {
  const toast = useToast();
  const [enableEdit, setEnableEdit] = useState(false);
  const [constraintWithWeightageData, setConstraintWithWeightageData] =
    useState(null);
  const [constraintWithNotWeightAgeData, setConstraintWithNotWeightAgeData] =
    useState(null);

  const [loading, setLoading] = useState(true);

  const bounds = useSelector((state) => state.app.bounds);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleChange = (e, type, tableName) => {
    let { name, value } = e.target;
    // console.log(name, value, type);
    value = isNaN(parseFloat(value)) ? "" : parseFloat(value);
    if (tableName === "secondTable") {
      setConstraintWithNotWeightAgeData((prev) => {
        const temp = {
          ...prev,
          [name]: { ...prev[name], [type]: value },
        };
        return temp;
      });
    } else {
      setConstraintWithWeightageData((prev) => {
        const temp = {
          ...prev,
          [name]: { ...prev[name], [type]: value },
        };
        return temp;
      });
    }
  };

  const handleClick = () => {
    enableEdit ? onOpen() : setEnableEdit((prev) => !prev);
    mixpanelTrackButton(
      "review constraints",
      enableEdit ? "SAVE" : "ENABLE EDITING"
    ); // mixpanel track button
  };

  const handleCancelEdit = () => {
    // make a get request to update state again;
    getConstraintsWithWeightageApi(setLoading)
      .then((res) => {
        const { aim, ...rest } = res;
        setConstraintWithWeightageData((prev) => aim);
        setConstraintWithNotWeightAgeData((prev) => rest);

        setEnableEdit((prev) => !prev);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const validateConstraints = (tempConstraints) => {
    for (const element in tempConstraints) {
      if (
        tempConstraints[element]["optimal"] === undefined ||
        tempConstraints[element]["optimal"] === ""
      ) {
        return {
          message: `Please fill the value of ${element}`,
          status: false,
        };
      }
    }

    return { status: true };
  };

  const validateTargetConstraints = (tempConstraints) => {
    for (const element in tempConstraints) {
      if (
        tempConstraints[element]["Ore"] === undefined ||
        tempConstraints[element]["Ore"] === "" ||
        tempConstraints[element]["Others"] === undefined ||
        tempConstraints[element]["Others"] === ""
      ) {
        return {
          message: `Please fill the value of ${element}`,
          status: false,
        };
      }
    }

    return { status: true };
  };

  const handleConfirmEdit = () => {
    const { message: msg1, status: status1 } = validateConstraints(
      constraintWithWeightageData
    );

    if (!status1) {
      toast({
        title: "Bounds not satisfied",
        status: "error",
        isClosable: true,
        description: msg1,
        duration: 3000,
      });
      return;
    }

    const { message: msg2, status: status2 } = validateTargetConstraints(
      constraintWithNotWeightAgeData
    );

    if (!status2) {
      toast({
        title: "Target sum not satisfied",
        status: "error",
        isClosable: true,
        description: msg2,
        duration: 3000,
      });
      return;
    }

    // console.log(constraintWithWeightageData);
    //   make a post/patch req to update the constraint in be
    updateConstraintsWithWeightageApi(
      constraintWithWeightageData,
      constraintWithNotWeightAgeData
    )
      .then((res) => {
        console.log(res);
        setEnableEdit((prev) => !prev);
        if (res.status === true) {
          toast({
            title: res.message,
            status: "success",
            isClosable: true,
            // description: res.message,
            duration: 3000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: "Error while updating",
          status: "error",
          isClosable: true,
          description: "Please try again",
          duration: 3000,
        });
      });
  };

  //   to load data on initial mount
  useEffect(() => {
    getConstraintsWithWeightageApi(setLoading)
      .then((res) => {
        console.log(res);
        const { aim, ...rest } = res;
        setConstraintWithWeightageData((prev) => aim);
        setConstraintWithNotWeightAgeData((prev) => rest);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //   console.log(tempConstraints);

  return (
    <>
      {loading ? (
        <p> Loading</p>
      ) : (
        <Box w="100%">
          <Flex w="98%" direction="column" mb="1rem" justify="right">
            <Button
              p="0"
              colorScheme="blue"
              w="150px"
              type="submit"
              onClick={handleClick}
              fontSize="12px"
            >
              {enableEdit ? "SAVE" : "ENABLE EDITING"}
            </Button>
          </Flex>
          <AlertModal
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            title="Upadate constraints"
            body="Are you sure? You want to change these constraints"
            colorScheme="red"
            onSubmit={handleConfirmEdit}
            onCancel={handleCancelEdit}
          />
          <TableContainer>
            <Table size="sm" colorScheme="gray">
              <Thead bg="#1a174e" borderColor="#1a174e">
                <Tr>
                  <Th color="white" p={0} textAlign="center">
                    Constraint
                  </Th>
                  <Th color="white" textAlign="center">
                    Value
                  </Th>
                  <Th color="white" p={0} textAlign="center">
                    Weightage Factors
                  </Th>
                </Tr>
              </Thead>
              <Tbody border="2px solid #e2e8f0">
                {constraintWithWeightageData &&
                  Object.keys(constraintWithWeightageData)
                    ?.sort()
                    ?.map((item, index) => (
                      <Tr key={index} border="2px solid #e2e8f0">
                        <Td p={2}>{item}</Td>
                        <Td p={0} justify="center" textAlign="center">
                          {/* value columns */}
                          <Input
                            type="number"
                            name={item}
                            placeholder={item}
                            w="50%"
                            h="100%"
                            p="4px"
                            m="auto"
                            borderRadius={0}
                            value={
                              constraintWithWeightageData[item]?.["optimal"]
                            }
                            disabled={!enableEdit}
                            onChange={(e) => handleChange(e, "optimal")}
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => e.target.blur()}
                            onScroll={(e) => e.target.blur()}
                          />
                        </Td>
                        {/* weightage column */}
                        <Td p={0} justify="center" textAlign="center">
                          <Input
                            type="number"
                            name={item}
                            placeholder={item}
                            w="50%"
                            h="100%"
                            p="4px"
                            m="auto"
                            borderRadius={0}
                            value={
                              constraintWithWeightageData[item]?.["weightage"]
                            }
                            disabled={!enableEdit}
                            onChange={(e) => handleChange(e, "weightage")}
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => e.target.blur()}
                            onScroll={(e) => e.target.blur()}
                          />
                        </Td>
                      </Tr>
                    ))}
              </Tbody>
            </Table>
          </TableContainer>

          <TableContainer mt="1rem">
            <Table size="sm" colorScheme="gray">
              <Thead bg="#1a174e" borderColor="#1a174e">
                <Tr>
                  <Th color="white" p={0} textAlign="center"></Th>
                  <Th color="white" textAlign="center">
                    Ore
                  </Th>
                  <Th color="white" p={0} textAlign="center">
                    Others
                  </Th>
                </Tr>
              </Thead>
              <Tbody border="2px solid #e2e8f0">
                {constraintWithNotWeightAgeData &&
                  Object.keys(constraintWithNotWeightAgeData)
                    ?.sort()
                    ?.map((item, index) => (
                      <Tr key={index} border="2px solid #e2e8f0">
                        <Td p={2}>{item}</Td>
                        <Td p={0} justify="center" textAlign="center">
                          {/* value columns */}
                          <Input
                            type="number"
                            name={item}
                            placeholder={item}
                            w="50%"
                            h="100%"
                            p="4px"
                            m="auto"
                            borderRadius={0}
                            value={
                              constraintWithNotWeightAgeData[item]?.["Ore"]
                            }
                            disabled={!enableEdit}
                            onChange={(e) =>
                              handleChange(e, "Ore", "secondTable")
                            }
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => e.target.blur()}
                            onScroll={(e) => e.target.blur()}
                          />
                        </Td>
                        {/* weightage column */}
                        <Td p={0} justify="center" textAlign="center">
                          <Input
                            type="number"
                            name={item}
                            placeholder={item}
                            w="50%"
                            h="100%"
                            p="4px"
                            m="auto"
                            borderRadius={0}
                            value={
                              constraintWithNotWeightAgeData[item]?.["Others"]
                            }
                            disabled={!enableEdit}
                            onChange={(e) =>
                              handleChange(e, "Others", "secondTable")
                            }
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => e.target.blur()}
                            onScroll={(e) => e.target.blur()}
                          />
                        </Td>
                      </Tr>
                    ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};
